export default __webpack_public_path__ + "static/media/stock_white.fb4ef710.svg";